





































































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import Loading from '@/app/components/Common/Loading.vue'
import CommonHeader from '@/app/components/Common/Header.vue'
import FieldSearch from '@/app/components/Field/FieldSearch.vue'
import FieldMap from '@/app/components/Field/FieldMap.vue'
import FieldList from '@/app/components/Field/FieldList.vue'
/* api */
import FieldListApi from '@/app/model/api/fieldListApi'
import FieldSortApi from '@/app/model/api/fieldSortApi'
import FieldDetailsApi from '@/app/model/api/fieldDetailsApi'
/* module */
import SelectClass from '@/app/module/select'
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import CommonClass from '@/app/module/common'
import { routerPath, fieldDetailsApiFlag, errorFlag } from '@/app/model/store/domain/const'

@Component({
  components: {
    Loading,
    CommonHeader,
    FieldSearch,
    FieldMap,
    FieldList
  }
})
export default class Field extends Vue {
  private target: string = this.$store.state.fieldState.accordionType
  private isActive: boolean = false
  private isOpend: any = {}
  /* 表示切り替え */
  private showNotFound: boolean = false
  private showFieldListLoading: boolean = true
  private accordionOpenFlag: boolean = true
  private accordionChangeFlag: boolean = true
  /* データ */
  private displayAccordionData: Array<{[key:string]: string|number}> = []
  private accordionList: Array<{[key:string]: string|number|any}> = []
  private accordionLoading: any = {}
  private mapList: Array<{[key:string]: any}> = []
  private displayMapList: Array<{[key:string]: any}> = []
  private fieldList: Array<{[key:string]: any}> = []
  private displayFieldList: Array<{[key:string]: any}> = []
  private fieldDetailsData: any[] = []
  private totalFieldCount: number = 0
  private accordionFlag: boolean = true
  private sortOrder: string = this.$store.state.fieldState.sortOrder
  private sort: string = this.$store.state.fieldState.sort
  private sortOrderSelected: any = [
    { text: '収穫適期までの日数', value: 'harvestForecastDays' },
    { text: '積算温度', value: 'integrationTemperature' },
    { text: '圃場名', value: 'fieldName' }
  ]
  private sortSelected: any = [
    { text: '昇順', value: 'asc' },
    { text: '降順', value: 'desc' }
  ]
  private groupList: {text: string, value: string}[] = SelectClass.groupList
  private defultFieldList: any = []

  private get sortChange (): any {
    return [this.sortOrder, this.sort]
  }

  @Watch('sortChange')
  getSortChange () {
    if (this.defultFieldList.length !== 0 && !this.showFieldListLoading) {
      this.showFieldListLoading = true

      this.changeSort(0)
      this.$store.commit('fieldState/setSortOrder', this.sortOrder)
      this.$store.commit('fieldState/setSort', this.sort)
      this.$store.commit('fieldState/setFieldSortFlag', false)
    }
  }

  private get fieldChoiceState (): number {
    return this.$store.state.fieldChoiceState.id
  }
  @Watch('fieldChoiceState')
  private onIdChange (newValue: string) {
    if (newValue !== '') {
      this.$router.push('#' + newValue).catch(e => {})
    }
  }
  @Watch('$route')
  private onRouteChange (to: {[key:string]: string}) {
    if (to.hash) {
      let el: any = document.getElementById(to.hash.replace(/^#/, ''))

      if (el !== null && el !== undefined) {
        let acoordionId = el.parentElement.parentElement.parentElement.previousElementSibling.getAttribute('id')
        let index = acoordionId.indexOf('/')
        let id = acoordionId.slice(index + 1)

        this.openSpecificAccordion(id)

        if (el && this.$store.state.fieldChoiceState.isScroll) {
          el.scrollIntoView({ behavior: 'instant' })
        } else {
          this.$store.commit('fieldChoiceState/setIsScroll', true)
        }
      } else {
        this.foundFieldAccordionId()
      }
    }
  }

  private foundFieldAccordionId () {
    for (let i in this.accordionList) {
      for (let j in this.accordionList[i].fields) {
        if (this.accordionList[i].fields[j].field_id === parseInt(this.$store.state.fieldChoiceState.id)) {
          if (!this.isOpend[this.accordionList[i].accordion_id]) {
            this.isOpenedAccordion(this.accordionList[i].accordion_id)
            break
          }
        }
      }
    }
  }

  created () {
    /* 検索結果を保持しているかどうか判定 */
    let stateData = this.$store.state.fieldState

    // 検索値が全て初期状態だったらlistApiをそのまま叩く処理
    if (stateData.fieldSearchStatus === 0 &&
        stateData.fieldSearchVariety === '' &&
        stateData.fieldSearchRisk === 0 &&
        stateData.fieldSearchText === '' &&
        stateData.accordionType === '1') {
      this.getFieldData('first')
    } else {
      this.doSearch(true)
    }
  }

  /* データ取得 */
  private async getFieldData (type: string) {
    this.showFieldListLoading = true
    let search: any = this.$refs.search
    if (search !== undefined) {
      search.requesting = true
    }

    /* ページの一番上を表示 */
    this.isActive = true
    let area: any = document.getElementById('fieldListContainer')!
    if (area !== null) {
      area.scrollTop = 0
    }

    let result
    if (type === 'search') {
      result = await FieldSortApi.doFieldSort(fieldDetailsApiFlag.FLAG_FIELD_TARGET, this.searchItem, [])
    } else {
      result = await FieldListApi.getFieldData(this.$store.state.fieldState.plantingOnly, '0', {})
    }

    if (result.isOk()) {
      /* 品種絞り込みのデータ */
      Local.setVarietiesData(JSON.stringify(result.getPayload().varieties))
      Local.setGrowthStageData(JSON.stringify(result.getPayload().growth_stage))
      Local.setRiskData(JSON.stringify(result.getPayload().risk))

      /* 圃場件数 */
      this.totalFieldCount = result.getPayload().total_field_count
      // グループ分けしていない圃場一覧を保持
      this.defultFieldList = result.getPayload().fields
      const fieldsGroub = this.groupBy(result.getPayload().fields, this.target)

      /* データ追加フラグ更新 */
      this.$store.commit('setFlagState/setSelectDataListFlag', true)
      this.$store.commit('setFlagState/setMySelectDataListFlag', true)

      /* マップのデータを作成 */
      if (result.getPayload().fields.length !== 0) {
        this.showNotFound = false
        this.makeAccordionData(fieldsGroub)

        /* マップデータ作成 */
        for (var j in result.getPayload().fields) {
          this.createDataList(result.getPayload().fields[j], parseInt(j))

          /* エリアデータをlocalstorageに保存 */
          let accordionData = result.getPayload().fields[j]
          accordionData['timestamp'] = Date.now()
        }
        this.mapCreate()
        this.displayMapList = this.mapList
        this.isActive = false
      } else {
        this.showNotFound = true
      }
      this.showFieldListLoading = false
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      this.showFieldListLoading = false
    }

    if (search !== undefined) {
      search.requesting = false
    }
    this.showFieldListLoading = false
  }

  private groupBy (array: any, key: any) {
    if (key === '1') {
      // 地区
      const accordionList = array.reduce(function (rv: any, x: any) {
        (rv[x.district.district_id] = rv[x.district.district_id] || []).push(x)
        return rv
      }, {})
      let list = []
      for (var k in accordionList) {
        list.push({
          accordion_id: accordionList[k][0].district.district_id,
          accordion_name: accordionList[k][0].district.district_code + '\n' + accordionList[k][0].district.district_name,
          sort_number: accordionList[k][0].district.sort_number,
          fields: accordionList[k]
        })
      }
      return list
    } else if (key === '2') {
      // 品種
      const accordionList = array.reduce(function (rv: any, x: any) {
        if (x.planting.variety === null) {
          (rv[x.planting.variety] = rv[x.planting.variety] || []).push(x)
        } else {
          (rv[x.planting.variety.variety_id] = rv[x.planting.variety.variety_id] || []).push(x)
        }
        return rv
      }, {})
      let list = []
      for (var l in accordionList) {
        if (accordionList[l][0].planting.variety === null) {
          list.push({
            accordion_id: 0,
            accordion_name: '（作付けなし）',
            sort_number: null,
            fields: accordionList[l]
          })
        } else {
          list.push({
            accordion_id: accordionList[l][0].planting.variety.variety_id,
            accordion_name: accordionList[l][0].planting.variety.variety_name,
            sort_number: null,
            fields: accordionList[l]
          })
        }
      }
      return list
    } else {
      // 生産者
      const accordionList = array.reduce(function (rv: any, x: any) {
        if (x.planting.user === null) {
          (rv[x.planting.user] = rv[x.planting.user] || []).push(x)
        } else {
          (rv[x.planting.user.user_id] = rv[x.planting.user.user_id] || []).push(x)
        }
        return rv
      }, {})
      let list = []
      for (var m in accordionList) {
        if (accordionList[m][0].planting.variety === null) {
          list.push({
            accordion_id: 0,
            accordion_name: '（作付けなし）',
            sort_number: null,
            fields: accordionList[m]
          })
        } else {
          list.push({
            accordion_id: accordionList[m][0].planting.user.user_id,
            accordion_name: accordionList[m][0].planting.user.user_name,
            sort_number: null,
            fields: accordionList[m]
          })
        }
      }
      return list
    }
  }

  private getSensorLatLng (sensorType: string, data: any) {
    if (sensorType === 'fieldServer' || sensorType === 'paddyWatch') {
      if (data !== null) {
        return data.point
      }
    } else {
      let displayNumber
      if (sensorType === 'fieldCom1') {
        displayNumber = 1
      } else {
        displayNumber = 2
      }
      for (let i in data) {
        if (data[i] !== undefined && data[i].display_number === displayNumber) {
          return data[i].point
        }
      }
    }
    return null
  }

  /* 取得したデータからリストを作成 */
  private createDataList (result: any, key: number) {
    const mapData: any = {
      id: result.field_id,
      path: result.polygon.point,
      strokeColor: result.polygon.polygon_color,
      fillColor: result.polygon.polygon_color,
      fieldComSensor1: this.getSensorLatLng('fieldCom1', result.field_cam_sensor),
      fieldComSensor2: this.getSensorLatLng('fieldCom2', result.field_cam_sensor),
      fieldServerSensor: this.getSensorLatLng('fieldServer', result.field_server_sensor),
      paddyWatchSensor: this.getSensorLatLng('paddyWatch', result.paddy_watch_sensor)
    }

    const fieldData: any = {
      fieldName: result.field_name,
      fieldId: result.field_id,
      plantingId: result.planting.planting_id,
      accordionDistrictId: this.getAccordionId('district', result.district),
      accordionVarietyId: this.getAccordionId('variety', result.planting.variety),
      accordionUserId: this.getAccordionId('user', result.planting.user)
    }

    if (result.polygon.point === null) {
      mapData.fieldPosition = {
        lat: parseFloat(result.point.lat),
        lng: parseFloat(result.point.lng)
      }
    }

    this.mapList[key] = mapData
    this.fieldList[key] = fieldData
  }

  private getAccordionId (key: string, data: any) {
    if (data === null) {
      return 0
    }

    if (key === 'district') {
      return data.district_id
    } else if (key === 'variety') {
      return data.variety_id
    } else {
      return data.user_id
    }
  }

  /* ポリゴン表示 */
  private mapCreate () {
    if (this.mapList.length !== 0) {
      /* リストの一番上のデータをマップの中心にする */
      if (Session.getChoiceFieldId()! === null) {
        if (this.mapList[0].path !== null) {
          if (this.$store.state.mapState.basicData.position.lng === this.mapList[0].path[0].lng) {
            this.$store.commit('mapState/setBaseData', this.mapList[0].path[1])
          } else {
            this.$store.commit('mapState/setBaseData', this.mapList[0].path[0])
          }
        } else {
          let lat
          let lng
          if (this.mapList[0].fieldPosition.lat !== undefined) {
            lat = this.mapList[0].fieldPosition.lat
            lng = this.mapList[0].fieldPosition.lng
          } else {
            lat = this.mapList[0].field_lat
            lng = this.mapList[0].field_lng
          }

          this.$store.commit('mapState/setBaseData', {
            lat: parseFloat(lat),
            lng: parseFloat(lng)
          })
        }
      } else {
        if (this.mapList[0].path !== null) {
          this.$store.commit('mapState/setBaseData', this.mapList[0].path[1])
        } else {
          let lat
          let lng
          if (this.mapList[0].fieldPosition.lat !== undefined) {
            lat = this.mapList[0].fieldPosition.lat
            lng = this.mapList[0].fieldPosition.lng
          } else {
            lat = this.mapList[0].field_lat
            lng = this.mapList[0].field_lng
          }

          this.$store.commit('mapState/setBaseData', {
            lat: parseFloat(lat),
            lng: parseFloat(lng)
          })
        }
      }
    }
  }

  /* 詳細データ取得 */
  private getFieldDetailsData (id: number, idFlag: boolean) : any {
    (async () => {
      if (id !== 0) {
        this.$set(this.accordionLoading, id, true)
        let searchItem = {
          accordion: this.target,
          refile: this.$store.state.fieldState.plantingOnly,
          stage: '',
          variety: '',
          risk: 0,
          word: ''
        }

        const result = await FieldDetailsApi.getFieldDetailsData(String(id), idFlag, fieldDetailsApiFlag.FLAG_FIELD, searchItem, [])
        if (result.isOk()) {
          if (result.getPayload() === null) {
            return
          }

          for (let i in result.getPayload().field_details) {
            this.fieldDetailsData.push(result.getPayload().field_details[i])
          }
          result.getPayload().field_details.unshift({ timestamp: Date.now() })

          Session.setFieldDetailsData(JSON.stringify(result.getPayload().field_details), String(id))

          // 保存したグルーピングの情報を保持
          Session.setChoiceGrouping(this.target)

          let fieldList: any = this.$refs.fieldList
          if (fieldList !== undefined) {
            for (var i in fieldList) {
              if (fieldList[i].id === id) {
                fieldList[i].showLoading = false
              }
            }
          }
        } else {
          const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
        }
        // 並び替え用にデータをセット
        for (let i in this.accordionList) {
          if (this.accordionList[i].accordion_id === id) {
            let data: any = this.fieldDetailsData
            for (let l in this.accordionList[i].fields) {
              for (let j in data) {
                if (this.accordionList[i].fields[l] !== null &&
                    this.accordionList[i].fields[l].planting !== undefined &&
                    data[j].planting !== undefined &&
                    this.accordionList[i].fields[l].planting.planting_id === data[j].planting.planting_id) {
                  this.accordionList[i].fields[l].intergration_temperature = data[j].planting.intergration_temperature
                  this.accordionList[i].fields[l].harvest_limit_date = data[j].planting.harvest_limit_date
                  break
                }
              }
            }
            break
          }
        }
        this.changeSort(id)
        this.$set(this.accordionLoading, id, false)
      } else {
        this.changeSort(null)
      }
    })()
  }

  private changeSort (id: number|null) {
    // ページの一番上を表示（並び順変更時のみ）
    if (id === 0) {
      const area: any = document.getElementById('fieldListContainer')!
      if (area !== null) {
        area.scrollTop = 0
      }
    }

    let newList = JSON.parse(JSON.stringify(this.accordionList))
    let key

    for (let i in newList) {
      let getDisplayAccordionData: any = this.displayAccordionData.filter(function (data: any) {
        if (id === null) {
          key = 0
        } else {
          key = newList[i].accordion_id
        }
        return (data.accordion_id === key)
      })

      /* 以下のアコーディオン内のみソートを実施
         ①全部ソートかつ既にアコーディオンを開いている
         ②作付けありかつ押下したアコーディオンと一致
         ③作付けなしかつ押下したアコーディオンidが0 */
      if ((id === 0 && getDisplayAccordionData[0].fields.length !== 0) ||
          newList[i].accordion_id === id ||
          (newList[i].accordion_id === 0 && id === null)) {
        if (this.sortOrder === 'fieldName') {
          if (this.sort === 'asc') {
            newList[i].fields.sort(
              function (a: any, b: any) {
                return (a.field_name < b.field_name ? -1 : 1)
              }
            )
          } else {
            newList[i].fields.sort(
              function (a: any, b: any) {
                return (a.field_name < b.field_name ? 1 : -1)
              }
            )
          }
        } else if (this.sortOrder === 'harvestForecastDays') {
          if (this.sort === 'asc') {
            newList[i].fields.sort(
              function (a: any, b: any) {
                // 収穫適期の残日数が無かったら0を代入
                if (a.harvest_limit_date === undefined) {
                  a.harvest_limit_date = 0
                }
                if (b.harvest_limit_date === undefined) {
                  b.harvest_limit_date = 0
                }

                return (a.harvest_limit_date < b.harvest_limit_date ? -1 : 1)
              }
            )
          } else {
            newList[i].fields.sort(
              function (a: any, b: any) {
                // 収穫適期の残日数が無かったら0を代入
                if (a.harvest_limit_date === undefined) {
                  a.harvest_limit_date = 0
                }
                if (b.harvest_limit_date === undefined) {
                  b.harvest_limit_date = 0
                }

                return (a.harvest_limit_date < b.harvest_limit_date ? 1 : -1)
              }
            )
          }
        } else {
          if (this.sort === 'asc') {
            newList[i].fields.sort(
              function (a: any, b: any) {
                // 積算温度が無かったら0を代入
                if (a.intergration_temperature === undefined) {
                  a.intergration_temperature = 0
                }
                if (b.intergration_temperature === undefined) {
                  b.intergration_temperature = 0
                }

                return (a.intergration_temperature < b.intergration_temperature ? -1 : 1)
              }
            )
          } else {
            newList[i].fields.sort(
              function (a: any, b: any) {
                // 積算温度が無かったら0を代入
                if (a.intergration_temperature === undefined) {
                  a.intergration_temperature = 0
                }
                if (b.intergration_temperature === undefined) {
                  b.intergration_temperature = 0
                }

                return (a.intergration_temperature < b.intergration_temperature ? 1 : -1)
              }
            )
          }
        }
        for (let q in this.displayAccordionData) {
          if (this.displayAccordionData[q].accordion_id === key) {
            this.displayAccordionData[q].fields = newList[i].fields
            break
          }
        }
      }
    }
    this.showFieldListLoading = false
    /* データ取得フラグ */
    this.$store.commit('setFlagState/setFieldDetailsDataFlag', true)
  }

  private searchItem: any

  /* 検索 */
  /*
   * openFlag=trueは画面遷移、ブラウザバッグの場合(検索状態保持のためアコーディオン開く)
   * openFlag=falseは検索ボタン押下時(アコーディオンを閉じる)
   */
  private async doSearch (openFlag: boolean) {
    this.showFieldListLoading = true
    let search: any = this.$refs.search
    if (search !== undefined) {
      search.requesting = true
    }

    this.isActive = true
    this.searchItem = {
      accordion: this.target,
      refile: this.$store.state.fieldState.plantingOnly,
      status: this.$store.state.fieldState.fieldSearchStatus,
      variety: this.$store.state.fieldState.fieldSearchVariety,
      risk: this.$store.state.fieldState.fieldSearchRisk,
      word: this.$store.state.fieldState.fieldSearchText
    }

    this.displayAccordionData = []
    this.fieldList = []
    this.displayFieldList = []
    /* アコーディオンを一度すべて閉じる */
    for (var i in this.accordionList) {
      let id = this.accordionList[i].accordion_id
      this.$set(this.isOpend, id, false)
    }
    this.getFieldData('search')

    // 選択している圃場のリセット
    this.$store.commit('fieldChoiceState/setChoosingFieldId', '')
    this.$router.push('/field').catch(e => {})
  }

  /* リセット */
  private resetFieldList () {
    if (this.showNotFound) {
      this.showNotFound = false
    }

    this.showFieldListLoading = true

    this.target = '1'
    this.$store.commit('fieldState/setAccordionType', this.target)
    /* アコーディオンを一度すべて閉じる */
    for (var i in this.accordionList) {
      let id = this.accordionList[i].accordion_id
      this.$set(this.isOpend, id, false)
    }

    // 選択している圃場のリセット
    this.$store.commit('fieldChoiceState/setChoosingFieldId', '')
    this.$router.push('/field').catch(e => {})
    Session.setChoiceFieldId('')

    this.displayAccordionData = []
    this.fieldList = []
    this.displayFieldList = []
    this.sortOrder = 'harvestForecastDays'
    this.sort = 'asc'
    this.$store.commit('fieldState/setSortOrder', this.sortOrder)
    this.$store.commit('fieldState/setSort', this.sort)
    this.getFieldData('reset')
  }

  /* アコーディオンのターゲット変更 */
  private async changeTarget () {
    this.showFieldListLoading = true
    this.$store.commit('fieldState/setAccordionType', this.target)

    /* アコーディオンを一度すべて閉じる */
    for (var i in this.accordionList) {
      let id = this.accordionList[i].accordion_id
      this.$set(this.isOpend, id, false)
    }
    this.displayAccordionData = []
    // 選択している圃場のリセット
    this.$store.commit('fieldChoiceState/setChoosingFieldId', '')
    this.$router.push('/field').catch(e => {})
    Session.setChoiceFieldId('')

    const fieldsGroub = this.groupBy(this.defultFieldList, this.target)
    this.makeAccordionData(fieldsGroub)

    this.showFieldListLoading = false
  }

  private makeAccordionData (fieldsGroub: any) {
    // リセット
    this.fieldList = []
    this.displayAccordionData = []
    let accordionList: any = []

    // アコーディオン名とIDをセット
    for (var k in fieldsGroub) {
      accordionList.push({
        accordion_id: fieldsGroub[k].accordion_id,
        accordion_name: fieldsGroub[k].accordion_name,
        sort_number: fieldsGroub[k].sort_number,
        fields: []
      })
    }

    // アコーディオンを並び替え
    if (this.target === '1') {
      accordionList.sort(function (a: any, b: any) {
        // 並び順の昇順
        if (a.sort_number < b.sort_number) {
          return -1
        }
        if (a.sort_number > b.sort_number) {
          return 1
        }
        // 地区名の昇順
        if (a.accordion_name < b.accordion_name) {
          return -1
        }
        if (a.accordion_name > b.accordion_name) {
          return 1
        }
        return 0
      })
    } else if (this.target === '2') {
      accordionList.sort(function (a: any, b: any) {
        // 品種名の昇順
        if (a.accordion_name < b.accordion_name) {
          return -1
        }
        if (a.accordion_name > b.accordion_name) {
          return 1
        }
        return 0
      })
    } else {
      accordionList.sort(function (a: any, b: any) {
        // 生産者名の昇順
        if (a.accordion_name < b.accordion_name) {
          return -1
        }
        if (a.accordion_name > b.accordion_name) {
          return 1
        }
        // user_idの昇順
        if (a.accordion_id < b.accordion_id) {
          return -1
        }
        if (a.accordion_id > b.accordion_id) {
          return 1
        }
        return 0
      })
    }

    this.accordionList = fieldsGroub
    this.displayAccordionData = accordionList

    setTimeout(this.foundFieldAccordionId, 100)
  }

  /* アコーディオン */
  private isOpenedAccordion (key: number) {
    let getAccordionData: any = []
    for (let i in this.displayAccordionData) {
      if (this.displayAccordionData[i].accordion_id === key) {
        getAccordionData = this.displayAccordionData[i]
      }
    }

    if (!this.accordionLoading[key]) {
      if (getAccordionData.fields.length === 0) {
        this.getFieldDetailsData(key, true)
        this.accordionOpenFlag = true
      } else {
        this.accordionOpenFlag = false
      }
      this.accordionChangeFlag = !this.accordionChangeFlag
      this.$set(this.isOpend, key, !this.isOpend[key])
    }
  }

  private openSpecificAccordion (areaId: string) {
    let key = parseInt(areaId)
    if (!this.isOpend[key] && !this.accordionLoading[key]) {
      this.getFieldDetailsData(key, true)
      this.$set(this.isOpend, key, true)
    }
  }

  private afterTransition () {
    let id = Session.getChoiceFieldId()
    let el: any = document.getElementById(String(id))

    // クリックでアコーディオンを開くときはscrollしない
    if (el && this.accordionOpenFlag) {
      el.scrollIntoView({ behavior: 'instant' })
    }

    this.accordionOpenFlag = true
  }
}
